import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { theme } from "../theme/theme";
import { financeCalculator } from "../utils/calcfncs";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useTranslation } from "react-i18next";
import { getCurrencyUnit } from "../utils/utilities";

const TransactionTypeCard = ({
  text,
  value,
  icon,
  color,
  bgcolor,
}: {
  text: string;
  value: string;
  icon: React.ReactElement;
  color: string;
  bgcolor: string;
}) => {
  const { userInfo } = useSelector((state: RootState) => state.app);
  return (
    <Card sx={{ bgcolor, color, borderRadius: "16px", height: "100%" }}>
      <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "0.2rem",
          }}
        >
          {icon}
          {/* <ArrowUpwardIcon /> */}
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ fontWeight: "fontWeightBold" }}
          >
            {text}
          </Typography>
        </Stack>
        <Typography
          variant="h5"
          sx={{
            wordBreak: "break-word",
            textAlign: "right",
            fontWeight: "fontWeightBold",
          }}
        >
          {getCurrencyUnit(userInfo?.currency ?? "")}
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

const MonthlySummary = () => {
  const transactions = useSelector(
    (state: RootState) => state.app.transactions,
  );
  const { income, expense, balance } = financeCalculator(transactions);
  const { t: tCommon } = useTranslation("common");

  return (
    // containerで要素を横並びにする。
    <Grid container spacing={{ xs: 1, md: 2 }} sx={{ marginBottom: 2 }}>
      <Grid size={4}>
        <TransactionTypeCard
          text={tCommon("transaction.income")}
          value={income.toLocaleString()}
          icon={<ArrowUpwardIcon />}
          color={"white"}
          bgcolor={theme.palette.incomeColor.main}
        />
      </Grid>
      <Grid size={4}>
        <TransactionTypeCard
          text={tCommon("transaction.expense")}
          value={expense.toLocaleString()}
          icon={<ArrowDownwardIcon />}
          color={"white"}
          bgcolor={theme.palette.expenseColor.main}
        />
      </Grid>
      <Grid size={4}>
        <TransactionTypeCard
          text={tCommon("transaction.balance")}
          value={balance.toLocaleString()}
          icon={<AccountBalanceIcon />}
          color={"white"}
          bgcolor={theme.palette.balanceColor.main}
        />
      </Grid>
    </Grid>
  );
};

export default MonthlySummary;
